module.exports = __webpack_public_path__ + "img/115.d4bc3ca1.svg";